/** What more than one screen says. A string earns a place here by appearing twice. */
export const common = {
  shell: {
    title: "JBNL Wedstrijden - Aanmelden",
    account: "Je account",
    signOut: "Uitloggen",
  },

  footer: {
    stichting: "Stichting Jeugdbrandweer Nederland",
    website: "JBNL Wedstrijden",
  },

  countdown: {
    opent: "De inschrijving opent over",
    sluit: "De inschrijving sluit over",
    gesloten: "De inschrijving is gesloten.",
    dagEnTijd_one: "{{count}} dag {{tijd}}",
    dagEnTijd_other: "{{count}} dagen {{tijd}}",
    // What a screen reader hears: days, then hours, so it is not read out every second.
    opentOver: "De inschrijving opent over {{resterend}}.",
    sluitOver: "De inschrijving sluit over {{resterend}}.",
    dag_one: "{{count}} dag",
    dag_other: "{{count}} dagen",
    uren: "{{aantal}} uur",
    minderDanEenUur: "minder dan een uur",
  },
  /** "Versie" and not "Version": it is on screen, so it is Dutch. */
  version: {
    label: "Versie {{version}}",
    commit: "Commit {{commit}}",
  },
  theme: {
    label: "Weergave: {{theme}}",
    system: "automatisch",
    light: "licht",
    dark: "donker",
  },

  /**
   * Shared because a korps choosing voorkeursdatums and an ondersteuner choosing dagen see the
   * same number from the same store, so both must round and label it alike (ADR-0053).
   */
  reistijd: {
    onbekend: "Onbekend",
    minuten: "± {{minuten}} min",
    uren: "± {{uren}} uur",
    urenMinuten: "± {{uren}} uur {{minuten}} min",
    sorteerOp: "Sorteer op",
    sorteerDatum: "Datum",
    sorteerReistijd: "Reistijd",
  },

  logoAlt: "Jeugdbrandweer Nederland",
  /** Interpolated rather than typed per sentence, so a new mailbox is one edit. */
  mailbox: "ict@jeugdbrandweer.nl",
  portaalUrl: "https://portaal.jeugdbrandweer.nl/",
  actions: {
    busy: "Bezig…",
    cancel: "Annuleren",
    save: "Opslaan",
    next: "Volgende",
    previous: "Vorige",
    backToStart: "Terug naar het begin",
  },
  selectAll: {
    label: "Alles selecteren",
    count: "({{selected}} van {{total}})",
  },
  table: {
    busy: "Bezig met laden…",
    export: "Exporteren",
    pager: {
      label: "Paginering",
      pageOfTotal: "Pagina {{page}} van {{total}}",
      gotoPage: "Ga naar pagina {{page}}",
      morePages: "Meer pagina's",
    },
  },
  errors: {
    /** `status` stays in the sentence: a support mail can be answered from it. */
    unexpected: "Er is iets misgegaan ({{status}}). Probeer het opnieuw.",
    seizoenen: "We konden de seizoenen niet ophalen. Laad de pagina opnieuw.",
    uitloggen: "Uitloggen is niet gelukt ({{status}}). Probeer het opnieuw.",
    sessie:
      "We konden niet controleren of je bent ingelogd ({{status}}). Laad de pagina opnieuw.",
  },
} as const;
